import React from 'react';
import { Typography } from 'fronton-react';
import { TConfigurator } from '../../../../types';
import { NoPhoto } from '../no-photo';
import { CardWrapper, ContentWrapper } from '../styled';
import { useAnalytics } from '../hooks';
import { CardPrice } from '../card-price';
import { categoryCard, imgStyles } from './styled';

type CategoryCardProps = {
	configurator: TConfigurator;
	wide: boolean;
};

export const CategoryCard = ({ configurator, wide }: CategoryCardProps) => {
	const { name, pageUrl, price, imageUrl, measurementUnit, isPriceStatic } = configurator;
	const { ref, analyticsClickHandler } = useAnalytics(configurator);

	return (
		<CardWrapper
			ref={ref}
			href={pageUrl}
			className={categoryCard}
			data-qa="card"
			onClick={analyticsClickHandler}
			wide={wide}
		>
			{imageUrl ? (
				<img
					src={imageUrl}
					alt={name}
					className={imgStyles}
					data-qa="card-photo"
					data-analyticsName="productPhotoLink"
				/>
			) : (
				<NoPhoto />
			)}
			<ContentWrapper>
				<Typography
					variant="s"
					size="body_short"
					as="h3"
					data-qa="card-name"
					data-analyticsName="productNameLink"
				>
					{name}
				</Typography>
				<CardPrice price={price} unit={measurementUnit} flexiblePrice={!isPriceStatic} />
			</ContentWrapper>
		</CardWrapper>
	);
};
